module.exports = __webpack_public_path__ + "img/contact-white-rounded-bg.94a984c3.svg";